import UnauthorizedLayout from './unauthorized-layout';

export default UnauthorizedLayout;
